import { useState, useEffect, useRef } from 'react';
import apiClient from '../services/api';

export function useUniversalProductSearch() {
  const [searchQuery, setSearchQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (searchQuery.trim().length < 2) {
      setResults([]);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);

    debounceRef.current = setTimeout(async () => {
      try {
        const response = await apiClient.get('/api/universal-products/search', {
          params: { q: searchQuery.trim(), limit: 8 }
        });
        setResults(response.data?.products || []);
      } catch {
        setResults([]);
      } finally {
        setIsSearching(false);
      }
    }, 300);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [searchQuery]);

  const clearResults = () => {
    setSearchQuery('');
    setResults([]);
  };

  return { results, isSearching, searchQuery, setSearchQuery, clearResults };
}
